/* src/app/vehicle/pages/vehicles/vehicles.component.scss */
.header {
  color: #00639c;
}
/*# sourceMappingURL=vehicles.component.css.map */
